// extracted by mini-css-extract-plugin
export default {"container":"R_g","isClosed":"R_fv","title":"R_cX","titleIcon":"R_fw","contentContainer":"R_cN"};